export default {
  namespaced: true,
  state: {
    snackbar: { active: false, color: "", mode: "", timeout: -1, text: "" }
  },
  mutations: {
    setSnackbar (state, value) {
      state.snackbar = { active: true, ...value  }
    },
  }
}
  